import * as React from 'react';
import { GetServerSideProps } from 'next';
import {
    getGuideArticlesServerSideProps,
    PageGuideArticlesProps,
} from 'server/page-props/get-guide-articles-server-side-props';
import PageGuides from 'components/pages/page-guides';
import PageNotFound from 'components/pages/page-not-found';

const GuidesPage: React.FC<PageGuideArticlesProps> = (props) => {
    if (props.pageNotFound) {
        return <PageNotFound />;
    }

    return <PageGuides {...props} />;
};

export default GuidesPage;

export const getServerSideProps: GetServerSideProps<PageGuideArticlesProps> =
    getGuideArticlesServerSideProps;
